import React, { useContext, useEffect } from "react";
import { useLocation } from "react-router-dom";
import Hero from "../DashBoardComponents/Hero";
import Providers from "../DashBoardComponents/Providers";
import Patients from "../DashBoardComponents/Patients";
import Clinic from "../DashBoardComponents/Clinic";
import FAQ from "../DashBoardComponents/FAQ";
import Contact from "../DashBoardComponents/Contact";
import Layout from "../Layout";
import Footer from "../DashBoardComponents/Footer";
import Query from "../DashBoardComponents/Query";
import DashboardNew from "./DashboardNew/DashboardNew";

function HomePage() {
  const location = useLocation();
  const loggedUserJson = localStorage.getItem("patientData");
  const loggedUser = loggedUserJson ? JSON.parse(loggedUserJson) : null;

  useEffect(() => {
    const hash = location.hash;
    if (hash) {
      const element = document.querySelector(hash);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [location]); // Listen to the entire location change

  return (
    <Layout>
      <div className="App overflow-x-hidden">
        {!loggedUser ? (
          <>
            <Hero />
            <main>
              <section id="providers">
                <Providers />
              </section>
              <section id="patients">
                <Patients />
              </section>
              <section id="clinic">
                <Clinic />
              </section>
              <Query />
              <FAQ />
              <Contact />
            </main>
            <Footer />
          </>
        ) : (
          <main>
            <section>
              <DashboardNew />
            </section>
          </main>
        )}
      </div>
    </Layout>
  );
}

export default HomePage;
